export default __webpack_public_path__ + "static/media/wave1.13ca7c9b.png";